import React, { useEffect, useState } from 'react';
import { getPreview } from '@debbie/cortex/dist/api/preview.js';
import { Email, Loading } from '../index.js';
import { parseText, getSubjectContent } from '../../utils/templates.js';
import { toHtml } from './utils.js';
const EmailPreview = (props) => {
    const [email, setEmail] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const fetchPreview = async () => {
        setIsLoading(true);
        const email = await getPreview(props.options.caseId, {
            subject: props.options.subject
                ? getSubjectContent(parseText(toHtml(props.options.subject), props.options.mentionSuggestions))
                : '',
            html: parseText(toHtml(props.options.html), props.options.mentionSuggestions),
        });
        setEmail({ ...email, subject: getSubjectContent(email.subject) });
        setIsLoading(false);
    };
    useEffect(() => {
        fetchPreview();
    }, []);
    if (!email || !email.html) {
        return null;
    }
    return isLoading ? (React.createElement(Loading, { style: { width: '100%', height: '40px' } })) : (React.createElement(Email, { interaction: { details: email }, noToggle: true }));
};
export default EmailPreview;
//# sourceMappingURL=EmailPreview.js.map